import quickFetch from 'quick-fetch'; // @ts-expect-error missing type decleration

import { buildErrorResponse } from 'hub-http/adapters/adapterUtils'; // @ts-expect-error missing type decleration

import { responseError } from 'hub-http/helpers/response';
export default ((name, isExpectedError = () => false) => {
  const earlyMetaRequest = quickFetch.getRequestStateByName(name);
  if (!earlyMetaRequest) return null;
  return new Promise((resolve, reject) => {
    earlyMetaRequest.whenFinished(result => {
      resolve(result);
      quickFetch.removeEarlyRequest(name);
    });
    earlyMetaRequest.onError((xhr, errorCode) => {
      const errorResponse = buildErrorResponse(xhr, `early request '${name}' failed`, errorCode);
      const expectedErrorResp = isExpectedError();

      if (!expectedErrorResp) {
        reject(responseError(errorResponse, `early request '${name}' failed`, errorCode));
      } else {
        resolve(expectedErrorResp);
      }

      quickFetch.removeEarlyRequest(name);
    });
  });
});